import React, { useEffect, useState } from 'react';
import LeagueList from '../LeagueList/LeagueList';
import './Home.css'

const Home = () => {

    const [allLeagues, setAllLeagues] = useState([]);
    const minimumLeagues = allLeagues.slice(0, 30);

    useEffect(() => {
        const url = `https://www.thesportsdb.com/api/v1/json/1/all_leagues.php`;
        fetch(url)
            .then(res => res.json())
            .then(data => setAllLeagues(data.leagues))
            .catch(error => console.log(error));
    }, [])


    return (
        <main>
            <section className="banner-container">
                <div className="container-fluid">
                    <div className="row">
                        <div className="banner-image">
                            <div className="banner-overlay"></div>
                            <h1 className="banner-title d-flex justify-content-center align-items-center">
                                League of Legends
                            </h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="teams-section">
                <div className="container">
                    <div className="row">
                        {
                            minimumLeagues.map(league => <LeagueList leagueInfo={league} key={league.idLeague} />)
                        }
                    </div>
                </div >
            </section>
        </main>
    );
};

export default Home;